(function() {
  if (window.__giftRemoveActive) return;
  window.__giftRemoveActive = true;

  const THRESHOLD = 6900;
  const GIFT_VARIANT_ID = 53261824688395;
  const CART_DRAWER_SECTION_ID = 'sections--25437815701771__cart-drawer';
  let isSyncing = false;
  let lastSignature = null;

  function cartUrl() {
    return `/cart.js?_=${Date.now()}`;
  }

  async function syncGiftProduct() {
    if (isSyncing) return;
    isSyncing = true;

    try {
      const cart = await fetch(cartUrl(), { cache: 'no-store' }).then(r => r.json());

      const signature = JSON.stringify(cart.items.map(i => [i.variant_id, i.quantity]));
      if (signature === lastSignature) return;
      lastSignature = signature;

      const giftItem = cart.items.find(i => i.variant_id === GIFT_VARIANT_ID);
      if (!giftItem) return; // kein Geschenk im Cart -> nichts zu tun

      const baseTotal = cart.total_price - giftItem.final_line_price;

      console.log('baseTotal:', baseTotal, '| Geschenk im Cart:', true);

      if (baseTotal < THRESHOLD) {
        const changeRes = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          cache: 'no-store',
          body: JSON.stringify({
            id: giftItem.key,
            quantity: 0,
            sections: CART_DRAWER_SECTION_ID,
            sections_url: window.location.pathname
          })
        });
        if (!changeRes.ok) {
          console.error('Gift remove failed', await changeRes.json().catch(() => ({})));
          return;
        }
        const changeBody = await changeRes.json();
        lastSignature = null;
        await refreshCartUI('line-item:change', changeBody);
      }
    } finally {
      isSyncing = false;
    }
  }

  async function refreshCartUI(baseEvent, sectionResponse) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent: baseEvent,
        cart: sectionResponse
      }
    }));
  }

  setInterval(syncGiftProduct, 1000);

  function init() {
    syncGiftProduct();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();